/** 後端「提示」模式的球場規則違規；操作已完成，只需讓使用者知道 */
export interface RuleWarning {
    rule: string;
    message: string;
}

const WARNING_SEPARATOR = '；';

/** 多條警告合成一則通知；沒有警告回傳 null */
export function formatRuleWarnings(warnings: RuleWarning[] | undefined | null): string | null {
    if (!warnings || warnings.length === 0) {
        return null;
    }
    return warnings.map((warning) => warning.message).join(WARNING_SEPARATOR);
}
